export function parseCalendarDate(value: string) {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day, 12));
}

export function formatCalendarDate(value: Date) {
  return [
    value.getUTCFullYear(),
    String(value.getUTCMonth() + 1).padStart(2, "0"),
    String(value.getUTCDate()).padStart(2, "0"),
  ].join("-");
}

export function addCalendarDays(value: string, days: number) {
  const date = parseCalendarDate(value);
  date.setUTCDate(date.getUTCDate() + days);
  return formatCalendarDate(date);
}

export function startOfCalendarWeek(value: string) {
  const date = parseCalendarDate(value);
  const offset = (date.getUTCDay() + 6) % 7;
  date.setUTCDate(date.getUTCDate() - offset);
  return formatCalendarDate(date);
}

export function calendarWeek(value: string) {
  const start = startOfCalendarWeek(value);
  return Array.from({ length: 7 }, (_, index) =>
    addCalendarDays(start, index),
  );
}

export function formatCalendarDay(
  value: string,
  options: Intl.DateTimeFormatOptions,
) {
  return new Intl.DateTimeFormat("en-JM", {
    ...options,
    timeZone: "UTC",
  }).format(parseCalendarDate(value));
}

export function formatCalendarWeekRange(weekStart: string) {
  const weekEnd = addCalendarDays(weekStart, 6);
  const start = formatCalendarDay(weekStart, {
    month: "short",
    day: "numeric",
  });
  const end = formatCalendarDay(weekEnd, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  return `${start} – ${end}`;
}
